// Remove collections variaveis para comparar apenas os campos base do payload.
const omitCollections = (value) => {
    if (!value || typeof value !== "object") return value;

    const { products, tags, ...rest } = value;
    return rest;
};

// Decide se deve mesclar lists com base na igualdade dos metadados do registro.
const shouldMergeCollections = (currentValue, nextValue) => {
    if (!currentValue || !nextValue) return false;

    return JSON.stringify(omitCollections(currentValue)) === JSON.stringify(omitCollections(nextValue));
};

export default {
    namespaced: true,
    state: {
        data: [],
        receiveToken: "",
    },
    mutations: {
        setReceiveToken: (state, token) => {
            state.receiveToken = String(token || "").trim();
        },
        // Substitui o registro atual ou mescla products/tags quando for o mesmo registro base.
        addRfidData: (state, value) => {
            const payloadToken = String(value?.token || "").trim();
            const activeReceiveToken = String(state.receiveToken || "").trim();

            if (payloadToken && activeReceiveToken && payloadToken !== activeReceiveToken) {
                return;
            }

            if (!payloadToken) {
                state.data = [...state.data, value];
                return;
            }

            const currentValue = state.data[0];

            if (shouldMergeCollections(currentValue, value)) {
                state.data = [{
                    ...currentValue,
                    ...value,
                    products: [
                        ...(Array.isArray(currentValue.products) ? currentValue.products : []),
                        ...(Array.isArray(value.products) ? value.products : []),
                    ],
                    tags: [
                        ...(Array.isArray(currentValue.tags) ? currentValue.tags : []),
                        ...(Array.isArray(value.tags) ? value.tags : []),
                    ],
                }];
                return;
            }

            state.data = [value];
        },
        // Limpa todos os dados RFID armazenados no estado.
        resetRfidData: (state) => {
            state.data = [];
        },
    },
}
